/**
 * Language-related types for multi-language support
 */

export enum eAllowedLangs {
  SK = 'sk',
  EN = 'en',
  CS = 'cs',
  DE = 'de',
  KO = 'ko',
  PT = 'pt',
}

export type AllowedLang = (typeof eAllowedLangs)[keyof typeof eAllowedLangs]

export type LangNameAttribute = Partial<Record<AllowedLang, string>>
